import { createSlice } from "@reduxjs/toolkit";

type IpoViewPageState = {
  object: {
    viewType?: string;
    key?: string;
    data?: any;
  };
};

const initialState: IpoViewPageState = { object: null };

const ipoViewPageSlice = createSlice({
  name: "ipoViewPage",
  initialState: initialState,
  reducers: {
    addObject: (state, action) => {
      const { key, data, viewType } = action.payload;
      state.object = { viewType, key, data };
    },
    removeObject: (state) => {
      state.object = null;
    },
  },
});

export const { addObject, removeObject } = ipoViewPageSlice.actions;

export default ipoViewPageSlice.reducer;
